import palette from 'theme/palette'

const components = {
  MuiButtonBase: {
    defaultProps: {},
  },
  MuiInput: {
    defaultProps: {
      disableUnderline: true,
    },
  },
  MuiInputBase: {
    defaultProps: {},
    styleOverrides: {
      root: {
        outline: '1px solid',
        outlineColor: `${palette['light-gray-text'].main}`,

        '&.Mui-focused': {
          outline: '1px  solid',
          outlineColor: `${palette['alternate'].main}`,
        },
        '&:hover': {},
        '&.Mui-disabled': {
          backgroundColor: `${palette['gray-background'].main}`,
          outline: '1px solid',
          outlineColor: `${palette['gray-line'].main}`,
        },
      },
      input: {
        color: '#3A3A3A',
        '&::placeholder': {
          color: `${palette['light-gray-text'].main}`,
          opacity: 1,
        },
      },
    },
  },
  MuiMenuItem: {
    defaultProps: {
      mx: 2,
    },
    styleOverrides: {
      root: {
        backgroundColor: 'transparent !important',
        '&:hover': {
          backgroundColor: '#EFFAF8 !important',
        },
        '&:focus': {
          backgroundColor: '#EFFAF8 !important',
        },
      },
    },
  },

  //DO NOT REMOVE THIS COMMENT. FOR FUTURE REFERENCE. DISABLE CUSTOM SCROLLBAR
  // MuiCssBaseline: {
  //   styleOverrides: {
  //     '*': {
  //       '&::-webkit-scrollbar': {
  //         width: '0.5em',
  //         height: '0.5rem',
  //       },
  //       '&::-webkit-scrollbar-track': {
  //         '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0)',
  //       },
  //       '&::-webkit-scrollbar-thumb': {
  //         backgroundColor: `${palette['light-gray-text-2'].main}`,
  //         borderRadius: '1rem',
  //       },
  //       '&::-webkit-scrollbar-thumb:hover': {
  //         backgroundColor: `${palette['light-gray-text-2'].main}`,
  //       },
  //       '&::-webkit-scrollbar-thumb:active': {
  //         backgroundColor: `${palette['light-gray-text'].main}`,
  //       },
  //     },
  //   },
  // },
  //DO NOT REMOVE THIS COMMENT. FOR FUTURE REFERENCE. DISABLE CUSTOM SCROLLBAR
}

export default components
